import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Ticker from "@/components/site/Ticker";
import Manifesto from "@/components/site/Manifesto";
import Brands from "@/components/site/Brands";
import Catalog from "@/components/site/Catalog";
import Applications from "@/components/site/Applications";
import QuoteForm from "@/components/site/QuoteForm";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function SiteHome() {
  return (
    <div data-testid="site-home" className="bg-background text-foreground">
      <Navbar />
      <Hero />
      <Ticker />
      <Manifesto />
      <Brands />
      <Catalog />
      <Applications />
      <QuoteForm />
      <Contact />
      <Footer />
    </div>
  );
}
